import React from "react";
import { Navigate } from "react-router-dom";

// Authentication related pages
import ForgetPwd from "../pages/Authentication/ForgetPassword";
import Login from "../pages/Authentication/Login";
import Logout from "../pages/Authentication/Logout";
import Error404 from "../pages/Utility/Error404";
import Maintenance from "../pages/Utility/Maintenance";
import Packages from "../pages/Packages/Packages";
import PackageBookings from "../pages/Packages/PackageBookings";
import BookingDetails from "../pages/Packages/BookingDetails";

const Dashboard = React.lazy(() => import("../pages/Dashboard/index"));
const AddPackage = React.lazy(() => import("../pages/Packages/AddPackage"));
const Appointments = React.lazy(() => import("../pages/Appointments/Appointments"));
const ViewAppointment = React.lazy(() => import("../pages/Appointments/ViewAppointment"));
const Teleconsult = React.lazy(() => import("../pages/Teleconsult/Teleconsult"));
const ViewTeleconsult = React.lazy(() => import("../pages/Teleconsult/ViewTeleconsult"));
const AddClinic = React.lazy(() => import("../pages/Clinic/AddClinic"));
const Clinic = React.lazy(() => import("../pages/Clinic/Clinic"));
const MaybankAppointments = React.lazy(() => import("../pages/MayBank PeEmployment/MaybankAppointments"));
const MaybankViewAppointment = React.lazy(() => import("../pages/MayBank PeEmployment/MaybankViewAppointment"));
const AddPatients = React.lazy(() => import("../pages/Patients/AddPatients"));
const Patients = React.lazy(() => import("../pages/Patients/Patients"));
const Viewpatient = React.lazy(() => import("../pages/Patients/Viewpatient"));
const General = React.lazy(() => import("../pages/Settings/General/General"));
const AddRoleAndPermission = React.lazy(() => import("../pages/Settings/Role And Permissions/AddRole"));
const RolesAndPermissions = React.lazy(() => import("../pages/Settings/Role And Permissions/RolesAndPermissions"));
const AddStaff = React.lazy(() => import("../pages/Staff/AddStaff"));
const EditPassword = React.lazy(() => import("../pages/Staff/EditPassword"));
const UserProfile = React.lazy(() => import("../pages/Staff/UserProfile"));
const NotAuthorized = React.lazy(() => import("../pages/Utility/NotAuthorized"));
const SetNewPassword = React.lazy(() => import("../pages/Authentication/SetNewPassword"));
const Doctors = React.lazy(() => import("../pages/Doctors/Doctors"));
const AddDoctors = React.lazy(() => import("../pages/Doctors/AddDoctors"));
const Campaigns = React.lazy(() => import("../pages/Campaigns/Campaigns"));
const CampaignForm = React.lazy(() => import("../pages/Campaigns/CampaignForm"));
const Testimonials = React.lazy(() => import("../pages/Testimonials/Testimonials"));
const Payment = React.lazy(() => import("../pages/Settings/Payment Configuration/Payment"));
const AddPayment = React.lazy(() => import("../pages/Settings/Payment Configuration/AddPayment"));
const PublicHoliday = React.lazy(() => import("../pages/Settings/Public Holiday/PublicHoliday"));
const AddPublicHoliday = React.lazy(() => import("../pages/Settings/Public Holiday/AddPublicHoliday"));

const StaffListing = React.lazy(() => import('../pages/Staff/StaffListing'));


const authProtectedRoutes = [

	//user
	// { path: "/user-profile", component: <Profile /> },
	{ path: "/staff-listing", component: <StaffListing />, requiredPermission: "view-admin", },
	{ path: "/add-staff", component: <AddStaff type="Add" title="Add Staff" />, requiredPermission: "create-admin" },
	{ path: "/edit-staff/:ID", component: <AddStaff type="Edit" title="Edit Staff" />, requiredPermission: "edit-admin" },
	{ path: "/view-staff/:ID", component: <AddStaff type="View" title="View Staff" />, requiredPermission: "view-admin" },
	{ path: "/edit-password/:ID", component: <EditPassword />, requiredPermission: "edit-admin" },

	// patients
	{ path: "/patient", component: <Patients />, requiredPermission: "view-member", },
	{ path: "/view-patient/:ID", component: <Viewpatient />, requiredPermission: "view-member", },
	{ path: "/add-patients", component: <AddPatients type="Add" title="Add Patients" />, requiredPermission: "create-member" },
	{ path: "/edit-patient/:ID", component: <AddPatients type="Edit" title="Edit Patients" />, requiredPermission: "edit-member" },

	//clinics
	{ path: "/clinic", component: <Clinic />, requiredPermission: "view-clinic" },
	{ path: "/add-clinic", component: <AddClinic type="Add" title="Add Clinic" />, requiredPermission: "create-clinic" },
	{ path: "/edit-clinic/:ID", component: <AddClinic type="Edit" title="Edit Clinic" />, requiredPermission: "edit-clinic" },

	//doctors
	{ path: "/doctor", component: <Doctors />, requiredPermission: "view-clinic" },
	{ path: "/add-doctor", component: <AddDoctors type="Add" title="Add Doctors" />, requiredPermission: "create-clinic" },
	{ path: "/edit-doctor/:ID", component: <AddDoctors type="Edit" title="Edit Doctors" />, requiredPermission: "edit-clinic" },

	//campaigns
	{ path: "/campaigns", component: <Campaigns />, requiredPermission: "view-campaign" },
	{ path: "/campaigns/new", component: <CampaignForm />, requiredPermission: "create-campaign" },
	{ path: "/campaigns/:id/edit", component: <CampaignForm />, requiredPermission: "edit-campaign" },
	{ path: "/testimonials", component: <Testimonials />, requiredPermission: "view-testimonial" },

	//packages
	{ path: "/packages", component: <Packages />, requiredPermission: "view-package" },
	{ path: "/packages/bookings/:id", component: <BookingDetails />, requiredPermission: "view-package" },
	{ path: "/packages/bookings", component: <PackageBookings />, requiredPermission: "view-package" },
	{ path: "/add-package", component: <AddPackage />, requiredPermission: "create-package" },
	{ path: "/edit-package/:id", component: <AddPackage type="Edit" />, requiredPermission: "edit-package" },

	//appoinment
	{ path: "/teleconsult", component: <Teleconsult />, requiredPermission: "view-teleconsultation" },
	{ path: "/view-teleconsult/:ID", component: <ViewTeleconsult type="View" />, requiredPermission: "view-teleconsultation", },
	{ path: "/edit-teleconsult/:ID", component: <ViewTeleconsult type="Edit" />, requiredPermission: "edit-teleconsultation", },

	//Teleconsult
	{ path: "/appointment", component: <Appointments />, requiredPermission: "view-appointment" },
	{ path: "/view-appointment/:ID", component: <ViewAppointment type="View" />, requiredPermission: "view-appointment", },
	{ path: "/edit-appointment/:ID", component: <ViewAppointment type="Edit" />, requiredPermission: "edit-appointment", },

	//Pre-Employment appoinment
	{ path: "/pre-employment", component: <MaybankAppointments />, requiredPermission: "view-preemployment_appointment" },
	{ path: "/view-pre-employment/:ID", component: <MaybankViewAppointment type="View" />, requiredPermission: "view-preemployment_appointment", },

	// Setting
	{ path: "/user-profile", component: <UserProfile /> },

	{ path: "/role-permissions", component: <RolesAndPermissions />, requiredPermission: "view-role" },
	{ path: "/add-role", component: <AddRoleAndPermission type="Add" title="Add Role" />, requiredPermission: "create-role" },
	{ path: "/edit-role/:ID", component: <AddRoleAndPermission type="Edit" title="Edit Role" />, requiredPermission: "edit-role" },
	{ path: "/view-role/:ID", component: <AddRoleAndPermission type="View" title="View Role" />, requiredPermission: "view-role" },

	{ path: "/general", component: <General title="Update General Settings" />, requiredPermission: "edit-general-setting" },

	//payment
	{ path: "/payment-configuration", component: <Payment />, requiredPermission: "view-general-setting" },
	{ path: "/add-payment-configuration", component: <AddPayment type="Add" title="Add Payment Method" />, requiredPermission: "create-general-setting" },
	{ path: "/edit-payment-configuration/:ID", component: <AddPayment type="Edit" title="Edit Payment Method" />, requiredPermission: "edit-general-setting" },


	//PublicHoliday
	{ path: "/date-configuration", component: <PublicHoliday />, requiredPermission: "view-general-setting" },
	{ path: "/add-date-configuration", component: <AddPublicHoliday type="Add" title="Add Public Holiday" />, requiredPermission: "create-general-setting" },
	{ path: "/edit-date-configuration/:ID", component: <AddPublicHoliday type="Edit" title="Edit Public Holiday" />, requiredPermission: "edit-general-setting" },


	{ path: "/dashboard", component: <Dashboard />, requiredPermission: "view-dashboard" },

	// this route should be at the end of all other routes
	{ path: "/", exact: true, component: <Navigate to="/dashboard" />, requiredPermission: "view-dashboard" },
];

const publicRoutes = [
	{ path: "/logout", component: <Logout /> },
	{ path: "/login", component: <Login /> },
	{ path: "/reset-password", component: <ForgetPwd /> },
	{ path: "/forgot-password/", component: <SetNewPassword /> },
	{ path: "/maintenance", component: <Maintenance /> },
	{ path: "/404", component: <Error404 /> },
	{ path: "/not-authorized", component: <NotAuthorized /> },
];

export { authProtectedRoutes, publicRoutes };

